import { message } from 'antd';
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWith409 from './baseQueryWith409';
import qs from 'qs';
import fetch from 'auth/FetchInterceptor';

// direct fetch without RTK Query
export const getTiposEstudios = query =>
	fetch.get(
		`/tipos-estudios${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const getTipoEstudio = ({ id, query }) =>
	fetch.get(
		`/tipos-estudios/${id}${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const addTipoEstudio = data => fetch.post('/tipos-estudios', data);
export const updateTipoEstudio = ({ id, ...data }) =>
	fetch.put(`/tipos-estudios/${id}`, data);
export const deleteTipoEstudio = id => fetch.delete(`/tipos-estudios/${id}`);

// RTK Query
export const tiposEstudiosApi = createApi({
	reducerPath: 'tiposEstudiosApi',
	baseQuery: baseQueryWith409,

	// default configuration
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: true,
	refetchOnFocus: true,

	//endpoints
	endpoints: build => ({
		getTiposEstudios: build.query({
			query: query => {
				return {
					url: `/tipos-estudios${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: result =>
				// is result available?
				result
					? // successful query
					  [
							...result.map(({ id }) => ({
								type: 'TiposEstudios',
								id,
							})),
							{ type: 'TiposEstudios', id: 'LIST' },
					  ]
					: // an error occurred, but we still want to refetch this query when `{ type: 'Posts', id: 'LIST' }` is invalidated
					  [{ type: 'TiposEstudios', id: 'LIST' }],
		}),
		getTipoEstudio: build.query({
			query: ({ id, query }) => {
				return {
					url: `/tipos-estudios/${id}${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: (result, error, id) => [{ type: 'TiposEstudios', id }],
		}),
		addTipoEstudio: build.mutation({
			query: data => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/tipos-estudios`,
					method: 'POST',
					body: JSON.stringify({
						data: {
							...data,
							created_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Tipo Estudio agregado exitosamente');
				} catch (error) {
					message.error('Error al agregar tipo estudio');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: [{ type: 'TiposEstudios', id: 'LIST' }],
		}),
		updateTipoEstudio: build.mutation({
			query: ({ id, ...data }) => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/tipos-estudios/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							...data,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Tipo Estudio actualizado exitosamente');
				} catch (error) {
					message.error('Error al actualizar tipo estudio');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, { id }) => [
				{ type: 'TiposEstudios', id },
			],
		}),
		deleteTipoEstudio: build.mutation({
			query: id => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/tipos-estudios/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							publishedAt: null,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Tipo Estudio eliminado exitosamente');
				} catch (error) {
					message.error('Error al eliminar tipo estudio');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, id) => [
				{ type: 'TiposEstudios', id },
			],
		}),
	}),
});

export const {
	useGetTiposEstudiosQuery,
	useGetTipoEstudioQuery,
	useAddTipoEstudioMutation,
	useUpdateTipoEstudioMutation,
	useDeleteTipoEstudioMutation,
} = tiposEstudiosApi;
